

import { useState , useEffect } from "react";
import Form from "/src/components/form/Form";
import { useModal } from "@ebay/nice-modal-react"
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import "./RolePermissionModalBody.css";
import "./RolePermissionModal.css";
import { useForm } from 'react-hook-form';
import ButtonAction from "/src/components/UI/Button/Button";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import PermissionIcon from "./templateForPermissions/PermissionIcon";
import CategoryIcon from "./templateForPermissions/CategoryIcon";
import roleService from "../../../services/roleService";
import Storage from "/src/utils/storage";
function RolePermissionModalBody({ data, title , role}) {

    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const { attachPermission, detachPermission} = roleService;
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
    const [deselectedPermissionIds, setDeselectedPermissionIds] = useState([]);
    const [selectedPermissionCount, setSelectedPermissionCount] = useState({});
    const { getCategoryIcon } = CategoryIcon();
    const [expandedCategory, setExpandedCategory] = useState(null);
    const currentUser = Storage('local').get('user');
    const groupedPermissions = data;

    const { handleSubmit} = useForm({
      mode: "onChange",
      defaultValues: {}
    });

    const handleCategoryIconClick = (categoryId) => {
      if (expandedCategory === categoryId) {
          setExpandedCategory(null);
      } else {
          setExpandedCategory(categoryId);
      }
    };

    const onSubmit = async () => {
      const selectedIds = selectedPermissionIds.join(',');
      const deselectedIds = deselectedPermissionIds.join(',');
    
      if (selectedIds || deselectedIds) {
        let attach, detach;
        if (selectedIds && deselectedIds) {
          attach = attachPermission;
          detach = detachPermission;
        } else if (selectedIds) {
          attach = attachPermission;
        } else {
          detach = detachPermission;
        }
    
        if (attach) {
          const [response, errors] = await attach(role.id, { permission: selectedIds });
          if (errors) {
            console.error('Error attaching permissions.');
          } else {
            console.log('Permissions attached successfully.');
          }
        }
    
        if (detach) {
          const [response, errors] = await detach(role.id, { permission: deselectedIds });
          if (errors) {
            console.error('Error detaching permissions.');
          } else {
            console.log('Permissions detached successfully.');
          }
        }
    
        setSelectedPermissionIds([]);
        setDeselectedPermissionIds([]);
        onClose();
      } else {
        console.log('No permissions selected or deselected.');
      }
    };
    
    const handleIconClick = (permissionId) => {
      const isActive = Object.values(groupedPermissions).some(group =>
        group.some(permission => permission.id === permissionId && permission.is_active)
      );
    
      if (selectedPermissionIds.includes(permissionId)) {
        setSelectedPermissionIds(prev => prev.filter(id => id !== permissionId));
      } else if (deselectedPermissionIds.includes(permissionId)) {
        setDeselectedPermissionIds(prev => prev.filter(id => id !== permissionId));
      } else if (isActive) {
        setDeselectedPermissionIds(prev => [...prev, permissionId]);
      } else {
        setSelectedPermissionIds(prev => [...prev, permissionId]);
      }
    };
    
    const handleSelectAll = (permissions) => {
      const filteredPermissions = permissions.filter(permission => !selectedPermissionIds.includes(permission.id));
      const newPermissionIds = filteredPermissions.map(permission => permission.id);
    
      // Filtrer les identifiants des permissions sélectionnées depuis la base de données
      const dbSelectedPermissionIds = Object.values(groupedPermissions)
        .flatMap(group => group.filter(permission => permission.is_active))
        .map(permission => permission.id);
    
      const finalPermissionIds = newPermissionIds.filter(id => !dbSelectedPermissionIds.includes(id));
    
      setSelectedPermissionIds(prevSelectedPermissionIds => [
        ...prevSelectedPermissionIds,
        ...finalPermissionIds.filter(id => !prevSelectedPermissionIds.includes(id))
      ]);
    }

    const handleDeselectAll = () => {
      setSelectedPermissionIds([]);
    } 


    
    const customTitlePermission = (permissionName) => {
      if(permissionName === "expel a user"){
        permissionName = "expel a user from a company"
      }
      
      if (permissionName === "delete a user"){
        permissionName = "delete a user's account"
      }

      return permissionName;
    }
    
    useEffect(() => {
      const newSelectedPermissionCount = {};
      Object.entries(data).forEach(([categoryId, permissions]) => {
        const selectedCount = permissions.filter(permission => selectedPermissionIds.includes(permission.id)).length;
        const deselectedCount = permissions.filter(permission => deselectedPermissionIds.includes(permission.id)).length;
        const activeCount = permissions.filter(permission => permissions.find(dbPermission => dbPermission.id === permission.id && dbPermission.is_active)).length;
       
        const totalCount = selectedCount + activeCount - deselectedCount
        
        newSelectedPermissionCount[categoryId] = `${totalCount}/${permissions.length}`;
      });
    
      setSelectedPermissionCount(newSelectedPermissionCount);
    }, [selectedPermissionIds, deselectedPermissionIds]);
    
  
    return (
        <div>
        <Form className="edit-container" onSubmit={handleSubmit(onSubmit)}>
            <Form.Title>{title} {role.slug}</Form.Title>
            <Form.Body className="body-editModalPermission-container">
                <div className="permission_container">
                  {Object.entries(groupedPermissions).map(([categoryId, permissions]) => (
                      permissions.length > 0 && (
                          <div key={categoryId} className='list-module'>
                              <div className='module-item'>
                                  <div className="category-icon" onClick={() => handleCategoryIconClick(categoryId)}>
                                      <div className="category-name">
                                        <IconButton  className="main-iconButton profil_action main_add-button space_tableButton dashboard_button"  icon={expandedCategory === categoryId ? "fas fa-chevron-down" : "fas fa-chevron-right"} />
                                        {getCategoryIcon(categoryId)} 
                                      </div>
                                      <span style={{fontSize:'16px', color:'var(--main)',marginRight:'5px'}}>({selectedPermissionCount[categoryId]})</span>
                                  </div>
                                  {expandedCategory === categoryId && (
                                      <div className="permissions-dropdown">
                                          <div className="select_permissions">
                                            {!(role.create_by_admin && !currentUser.is_admin) && (<div className="select-all-option" onClick={() => handleSelectAll(permissions)}>Select All</div>)}
                                            {/* <div className="select-all-option" onClick={() => handleDeselectAll(permissions)}>Deselect All</div> */}
                                          </div>
                                          {permissions
                                            .filter(permission => !(permission.slug === 'delete_user' && !currentUser.is_admin))
                                            .map(permission => (
                                                <div key={permission.id} className={`module-item-icon-badge ${permission.slug === 'view_home' || (role.create_by_admin && !currentUser.is_admin)  ? 'disabled' : ''}`}  title={customTitlePermission(permission.name)}>
                                                    <PermissionIcon slug={permission.slug} onClick={() => handleIconClick(permission.id)} />
                                                    <span className={selectedPermissionIds.includes(permission.id) ? 'badge-active' : deselectedPermissionIds.includes(permission.id) ? 'badge-desactive' : permission.is_active ? 'badge-active' : 'badge-desactive'}></span>
                                                </div>
                                            ))
                                          }
                                    </div>
                                  )}
                              </div>
                          </div>
                      )
                  ))}
                </div>
            </Form.Body>
            {/* <br/><br/><br/> */}
            {(currentUser.is_admin || !role.create_by_admin)  &&(
              <Form.Buttons>
                <ButtonAction type="submit" label={"OK"} style={{marginTop:'230px'}}  onSubmit={onSubmit}>
                </ButtonAction>
              </Form.Buttons>
            )}
        </Form>
    </div>

    );
}

export default RolePermissionModalBody;